/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Storage account container.
*/
export class StorageAccountContainerRestoreDestination {
  /**
  * Name of the resource group that contains the storage account. 
  */
  'storageAccountResourceGroupName': string;
  /**
  * Name of the storage account to restore query results to. 
  */
  'storageAccountName': string;
  /**
  * Name of an existing container to restore query results to. 
  */
  'containerName': string;
  /**
  * Prefix to prepend to the restore path. If omitted, query results are restored to the container root. 
  */
  'prefix'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "storageAccountResourceGroupName",
      "baseName": "storageAccountResourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageAccountName",
      "baseName": "storageAccountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "containerName",
      "baseName": "containerName",
      "type": "string",
      "format": ""
    },
    {
      "name": "prefix",
      "baseName": "prefix",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StorageAccountContainerRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

